import React from 'react';
import { IconBase } from './IconBase';

export const IconClose = (props) => (
    <IconBase viewBox="0 0 24 24" {...props}>
        <g id="Icon-/-Regular-/-Close-/-Gray">
            <path
                d="M16.707,15.2938 C17.098,15.6848 17.098,16.3168 16.707,16.7078 C16.512,16.9028 16.256,17.0008 16,17.0008 C15.744,17.0008 15.488,16.9028 15.293,16.7078 L12,13.4148 L8.707,16.7078 C8.512,16.9028 8.256,17.0008 8,17.0008 C7.744,17.0008 7.488,16.9028 7.293,16.7078 C6.902,16.3168 6.902,15.6848 7.293,15.2938 L10.586,12.0008 L7.293,8.7078 C6.902,8.3168 6.902,7.6848 7.293,7.2938 C7.684,6.9028 8.316,6.9028 8.707,7.2938 L12,10.5868 L15.293,7.2938 C15.684,6.9028 16.316,6.9028 16.707,7.2938 C17.098,7.6848 17.098,8.3168 16.707,8.7078 L13.414,12.0008 L16.707,15.2938 Z M12,2.9998 C7.029,2.9998 3,7.0288 3,11.9998 C3,16.9708 7.029,20.9998 12,20.9998 C16.971,20.9998 21,16.9708 21,11.9998 C21,7.0288 16.971,2.9998 12,2.9998 Z"
                id="Fill-1"
            />
        </g>
    </IconBase>
);

IconClose.defaultProps = {
    size: '24px',
    fill: '#A3A7B0',
};

IconClose.displayName = 'Close';

export default IconClose;
